<div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <ng-container *ngIf="!isError">
    <div class="p-heading-area01 u-mt-sp-20 u-mt-tb-20 u-mt-pc-24">
      <div class="p-heading-area01__title">
        <h2 class="c-heading-2">
          <span class="c-text-with-tooltip">
            <span class="c-text-with-tooltip__text" [innerHTML]="'label.fareRule' | staticMsg"></span>
          </span>
        </h2>
      </div>
      <div *ngIf="!isLoad" class="p-heading-area01__sub-function">
        <!-- 運賃ルール詳細モーダル表示ボタン -->
        <asw-button
          id="plan-review-fare-rules-component-open-fare-details-modal-btn"
          type="tertiary"
          size="xs"
          (click$)="openFareConditionDetails()"
          throttleClick
          [label]="fareDetailsModalBtnLabel"
          [disabled]="!isPlanValid"
        ></asw-button>
      </div>
    </div>

    <!-- APIレスポンス取得完了後 -->
    <ng-container *ngIf="!isLoad">
      <!-- 以下、PTC毎に繰り返し -->
      <ng-container *ngFor="let infoPerPtc of outputFareConditions">
        <asw-plan-review-fare-conditions-per-ptc
          [isPlanValid]="isPlanValid"
          [data]="infoPerPtc"
          [isAwardBooking]="isAwardBooking"
        ></asw-plan-review-fare-conditions-per-ptc>
      </ng-container>
      <!-- ここまで、PTC毎に繰り返し -->
    </ng-container>

    <!-- ローディング中 -->
    <ng-container *ngIf="isLoad">
      <div class="p-plan-table js-plan-table01-item" [ngClass]="{ 'grey-bg': !isPlanValid }">
        <div class="c-loading-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="Now Loading">
          <div class="c-loading-bar__line c-loading-bar__line--type2"></div>
          <div class="c-loading-bar__line c-loading-bar__line--type1"></div>
          <div class="c-loading-bar__line c-loading-bar__line--type1"></div>
          <div class="c-loading-bar__line c-loading-bar__line--type2"></div>
          <div class="c-loading-bar__line c-loading-bar__line--type3"></div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
